export default {
  SET_STATE(state, { action, data }) {
    state[action] = data
  }
}
